module.exports = __webpack_public_path__ + "img/jord.0014b19f.png";